<template>
    <div v-if="visible" class="modal-overlay">
        <div class="modal-content">
            <form @submit.prevent="onSubmit">
                <div class="row row-space">
                    <div class="form-item">
                        <label class="label-caption">Justificativa</label>
                        <textarea v-model="edJustificativa" maxlength="2000" rows="5" />
                    </div>
                </div>

                <div class="row-end">
                    <button type="button" class="btn-small" @click="closeModal">Voltar</button>
                    <button type="submit" class="btn-small btn-save">Confirmar</button>
                </div>
            </form>
        </div>
    </div>
</template>


<script setup>
import { ref } from 'vue';

const visible = ref(false);
const edJustificativa = ref('');
let resolvePromise = null;

const show = () => {
    edJustificativa.value = '';
    visible.value = true;

    return new Promise((resolve) => {
        resolvePromise = resolve;
    });
};

const onSubmit = () => {
    visible.value = false;

    if (resolvePromise) {
        resolvePromise({
            confirmado: true,
            justificativa: edJustificativa.value,
        });
    }

    resolvePromise = null;
};

const closeModal = () => {
    visible.value = false;

    if (resolvePromise) {
        resolvePromise({
            confirmado: false,
            justificativa: null,
        });
    }

    resolvePromise = null;
};

defineExpose({ show });
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 600px;
}
</style>
  